import React, { useState, useRef, useEffect } from 'react';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

import appapi from '../../../api/apiClient';
import { showmessage } from '../../../utils/toastr';
import { buttonStyle1, dialogButtonCancel } from '../../../utils/commonStyle';
import { colors } from '../../../utils/colors';
import { setLoading } from '../../../redux/features/appSlice';
import { useDispatch } from 'react-redux';
import FormTextField from '../../../components/FormTextField';
import background from '../../../assets/images/bg.png';
import AuthLayout from '../../../components/AuthLayout';
import LanguageSwitcher from '../../../components/LanguageSwitcher';
import { useTranslation } from 'react-i18next';

/**
 * Validation Schema for register
 */
const validationSchema = yup.object({
  email: yup
    .string('Enter your Email')
    .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, '*Invalid Email Address')
    .required('')
    .trim(),
});

export default function ForgotPassword() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1000px)');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { email } = state;

  const formRef = useRef();

  const theme = useTheme();

  const [hasFocused, setHasFocused] = useState(false);

  const [data, setData] = useState({
    email: '',
  });

  useEffect(() => {
    if (email) {
      setData({ email: email });
      setHasFocused(true);
    } else {
      setHasFocused(false);
    }
  }, [email]);

  const [formSubmitted, SetFormSubmitted] = useState(false);
  const [resend, SetResend] = useState(false);

  /**
   *
   * @param {email} obj
   * This submit is for reseting password
   */

  const resetPassword = async (obj, resend = false) => {
    dispatch(setLoading(true));
    let email = obj.email;
    let payload = {
      email: obj?.email ? obj.email : data.email,
    };
    const response = await appapi.post(`auth/forgetPassword`, payload);
    if (response.ok) {
      const data = response.data;
      dispatch(setLoading(false));
      if (data.status === '7400') {
        SetFormSubmitted(true);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  /**
   *
   * @returns Redirect to initial page which is login
   */

  const onClickLoginRoute = () => navigate(`/login`);
  // const onClickOtpRoute = (id, email) =>
  //   navigate(`/otp/${id}/${email}`, {
  //     state: { email: data.email, otpId: id },
  //   });

  //emailForm
  const form = () => {
    return (
      <>
        <Stack style={{ backgroundColor: '#FFFFFF', borderRadius: '8px' }}>
          <Typography
            className="fw-medium ff-Roboto createHeading !mt-[16px] !mx-[16px]"
            color={theme.palette.primary.text}
            fontSize={'16px'}
          >
            {t('auth.ForgotPassword')}
          </Typography>
          <Stack style={{ backgroundColor: '#F2F2F2', width: '100%', height: '1px', marginTop: '16px' }} />
          <Typography
            className="fs-14 ff-Roboto fw-regular !mt-[16px] !mx-[16px]"
            color={theme.palette.text.primary.text}
          >
            {t('auth.ForgotPasswordInstruction')}
          </Typography>
          <Formik
            innerRef={formRef}
            enableReinitialize={true}
            initialValues={{
              email: data?.email || '',
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => resetPassword(values)}
          >
            {({ handleSubmit, values, handleChange, errors, touched, handleBlur, isValid, dirty }) => (
              <Form
                style={{}}
                noValidate
                autoComplete="off"
              >
                <Stack
                  flex={1}
                  className="mt-[16px] mx-[16px]"
                  sx={{ mb: '14px' }}
                >
                  <FormTextField
                    outlineLabel={t('auth.Email')}
                    name="email"
                    sx={{ mb: 0 }}
                    lowerCase={true}
                  />
                </Stack>
                <Stack className="!px-[16px] !pb-[16px]">
                  <Button
                    sx={{
                      ...buttonStyle1,
                      marginBottom: '0',
                      width: '100%',
                      mt: '2.3px',
                      backgroundColor: theme.palette.primary.main,
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                        color: '#fff',
                      },
                      '&:disabled': {
                        color: 'rgba(255,255,255,0.5)',
                        backgroundColor: theme.palette.primary.main,
                      },
                    }}
                    disabled={!hasFocused ? !(dirty && isValid) : !isValid || !hasFocused}
                    type="submit"
                  >
                    {t('auth.send')}
                  </Button>
                </Stack>
              </Form>
            )}
          </Formik>
        </Stack>
      </>
    );
  };

  const formSubmittedContent = () => {
    return (
      <Stack className="bg-white p-[16px]">
        <Typography
          className="fw-bold ff-Roboto createHeading !mb-3"
          color={theme.palette.primary.text}
        >
          {(t('Successful'))}
        </Typography>
        <Typography
          className="fs-12 ff-Roboto fw-regular "
          color={theme.palette.primary.text}
        >
          {(t('Your request has been submitted successfully. Please check your email for further instructions'))}
        </Typography>
        {/* {resend ? (
          ''
        ) : (
          <Stack
            direction="row"
            style={{ marginTop: '7px' }}
            spacing={0.5}
          >
            <Typography
              className="ff-Roboto fw-regular fs-12"
              color={colors.gray}
            >
              Click here to
            </Typography>
            <Typography
              onClick={() => resetPassword({}, true)}
              className="ff-Roboto fw-bold fs-12"
              color={colors.primaryDark}
              style={{ cursor: 'pointer' }}
            >
              Resend
            </Typography>
            <Typography
              className="ff-Roboto fw-regular fs-12"
              color={colors.gray}
            >
              mail
            </Typography>
          </Stack>
        )} */}
        <Button
          sx={{
            ...buttonStyle1,
            marginBottom: '0',
            marginTop: '31px',
            textTransform: 'capitalize',
            width: '100%',
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
            color: '#FFFFFF',
          }}
          onClick={onClickLoginRoute}
        >
          {(t('Go Back To Login'))}
        </Button>
      </Stack>
    );
  };

  return (
    <AuthLayout>
      <Stack
        style={{ maxWidth: '300px', minWidth: '300px' }}
        direction="row"
        alignSelf="center"
      >
        <Stack
          className="leftStack"
          style={{ width: '100%' }}
        >
          <Stack className="formSubmittedStyle mt-28">
            <Stack>
              <Typography
                color={'#FFFFFF'}
                className="fw-medium ff-Roboto"
                style={{ fontSize: '24px', lineHeight: '24px' }}
              >
                {t('CarbonWallet')}
              </Typography>
              <Typography
                color={'#FFFFFF'}
                className="fw-medium ff-Roboto"
                style={{ fontSize: '16px', lineHeight: '24px' }}
              >
                {t('By ZeroEmissions')}
              </Typography>
            </Stack>
            <div
              style={{
                marginTop: '24px',
              }}
            >
              {formSubmitted ? <>{formSubmittedContent()}</> : <>{form()}</>}
              {!formSubmitted && (
                <Stack alignItems={'center'}>
                  <Typography
                    className="!my-[16px] fw-medium ff-Roboto "
                    fontSize={'12px'}
                    color={'#FFFFFF'}
                  >
                   {t('auth.or')}
                  </Typography>
                  {/* <Button
                  sx={{
                    ...buttonStyle2,
                    marginBottom: '0',
                    marginTop: '31px',
                    textTransform: 'capitalize',
                    width: '100%',
                    // backgroundColor: theme.palette.primary.main,
                    '&:hover': {
                      // backgroundColor: theme.palette.primary.dark,
                    },
                    color: theme.palette.background.main,
                    borderWidth: '1px',
                    borderColor: '#FFFFFF',
                  }}
                  onClick={onClickLoginRoute}
                >
                  Login
                </Button> */}
                  <Button
                    sx={[
                      dialogButtonCancel,
                      {
                        color: '#FFFFFF',
                        borderColor: '#FFFFFF',
                        backgroundColor: '#14285A1A',
                      },
                    ]}
                    style={{ width: '100%' }}
                    variant="outlined"
                    onClick={onClickLoginRoute}
                  >
                    {t('auth.Login')}
                  </Button>
                </Stack>
              )}
            </div>
          </Stack>
        </Stack>
      </Stack>
      <div style={{ position:'absolute', top: '16px', right: '16px'}}>
        <LanguageSwitcher />
      </div>
    </AuthLayout>
  );
}
